import {
  ABOUT_STATE,
  HOW_IT_WORKS_STATE,
  INITIAL_PAGE_STATE,
  REPORT_PAGE_STATE,
  LOGIN_STATE_NEW,
} from 'constants/constants';
import { Trigger } from 'types/trigger';
import { Views } from './types';

interface UseInitialPageViewParams {
  page: string;
  trigger: Trigger;
  isAngularLoaded: boolean;
  isConfigLoaded: boolean;
}

export const getInitialPageView = ({
  page,
  isAngularLoaded,
  trigger,
  isConfigLoaded,
}: UseInitialPageViewParams): Views | null => {
  // First check for skeleton page condition
  if (!isConfigLoaded || !isAngularLoaded || !trigger) {
    return Views.SkeletonPage;
  }

  switch (page) {
    case INITIAL_PAGE_STATE:
      return trigger === Trigger.Lst ? Views.InitialPageLst : Views.InitialPage;

    case REPORT_PAGE_STATE:
      return Views.ReportPage;

    case ABOUT_STATE:
      return Views.AboutPage;

    case HOW_IT_WORKS_STATE:
      return Views.HowItWorksPage;

    case LOGIN_STATE_NEW:
      return Views.Login;

    default:
      return null;
  }
};
